import { render, staticRenderFns } from "./sectionTitle.vue?vue&type=template&id=0a389f4a&scoped=true"
import script from "./sectionTitle.vue?vue&type=script&lang=js"
export * from "./sectionTitle.vue?vue&type=script&lang=js"
import style0 from "./sectionTitle.vue?vue&type=style&index=0&id=0a389f4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a389f4a",
  null
  
)

export default component.exports